module.exports = __webpack_public_path__ + "static/media/cancelx.d6dc5449.svg";